import { Component, input, linkedSignal } from '@angular/core';
import { iaIconChevronDownRounded } from '@bcef/ia-icons';
import { IconComponent, provideIcons } from '@bcef/ia-ng-icons';

let counter = 0;

@Component({
  selector: 'ia-resil-contrats-expandabled-item',
  imports: [IconComponent],
  providers: [provideIcons(iaIconChevronDownRounded)],
  templateUrl: './expandabled-item.component.html',
  host: {
    '[class.active]': '_expanded()',
    '[attr.active]': '_expanded()',
  },
})
export class ExpandabledItemComponent {
  public readonly showIcon = input(false);

  public readonly iconName = input('');

  public readonly title = input('');

  public readonly id = input(`ia-resil-contrats-expandabled-item-${counter++}`);

  public readonly expanded = input(false);

  public readonly _expanded = linkedSignal(() => this.expanded());

  public toggleExpanded(event: Event): void {
    event.stopPropagation();
    this._expanded.set(!this._expanded());
  }
}
